<template>
  <div class="TourPage">
    <Breadcrumbs>
      <router-link class="active" :to="{ name: 'guidedTours' }">{{
        this.getNavName('NAV_GUIDED_TOURS')
      }}</router-link>
      <span v-if="tour.name">{{ tour.name }}</span>
    </Breadcrumbs>
    <div class="pageBlock">
      <smoothReflow>
        <button class="backButton" type="button" @click="this.$router.go(-1)">
          {{ $t('NAV_BACK') }}
        </button>
        <div class="pageHeader">
          <h1>{{ tour.name }}</h1>
        </div>
        <Loading :visible="isLoading" size="medium" type="fullPage"></Loading>
        <div class="tour" v-if="tour.id">
          <div class="form"><GuidedTourForm></GuidedTourForm></div>
          <div class="imageContainer">
            <ImageC
              class="tourImage"
              v-if="tour.eventImage"
              :srcSuffix="tour.eventImage"
              @load="imageLoaded"
            />
          </div>
          <p class="tourDescription" v-html="tour.description_shop_long"></p>
        </div>
      </smoothReflow>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Loading from '../Loading.vue';
import GuidedTourForm from './GuidedTourForm.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import scroller from '../../scroller';
import ImageC from '../ImageC.vue';
import { setPageTitle } from '../../lib/pageTitle';
import { useSeoMeta } from '@unhead/vue';
import strip from '../../lib/stripHtml';

export default {
  name: 'GuidedToursSingle',
  components: {
    Loading,
    GuidedTourForm,
    Breadcrumbs,
    ImageC,
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      tour: (state) => state.guidedTours.data.single,
      publicURL: (state) => state.app.API_PUBLIC_URL,
      isLoading: (state) => state.guidedTours.isLoadingSingle,
      isNotFoundSingle: (state) => state.guidedTours.isNotFoundSingle,
      navTranslations: (state) => state.app.navTranslations,
    }),
  },
  methods: {
    ...mapActions({
      getSingle: 'guidedTours/single',
      clearForm: 'guidedTours/clearForm',
      clearSingleCalendar: 'guidedTours/clearSingleCalendar',
    }),
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
    scrollToDescription() {
      scroller(document.querySelector('#description'), 600, 'easeOutQuad');
    },
    imageLoaded(e) {
      e.classList.add('loaded');
    },
    setMeta() {
      let title = '';
      let description = '';
      let image = '';

      title = this.tour.name;
      description = strip(this.tour.description_shop_long);

      if (this.tour.metadata) {
        description = strip(this.tour.metadata);
      }
      const baseURL = this.$store.state.app.API_PUBLIC_URL;
      image = `${baseURL}/1600/${this.tour.tourImage}`;

      useSeoMeta({
        title: title,
        ogTitle: title,
        description,
        ogDescription: description,
        ogImage: image,
      });
    },
  },
  mounted() {
    this.clearForm().then(() => {
      this.getSingle(this.$route.params.id).then(() => {
        if (this.isNotFoundSingle) {
          this.$router.replace({ name: 'pageNotFound' });
        } else {
          setPageTitle(`${this.tour.name} - ${this.getNavName('NAV_GUIDED_TOURS')}`);
          this.setMeta();
        }
      });
    });
  },
  beforeUnmount() {
    this.clearSingleCalendar();
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
@import '../../scss/scaffolding'; // img-responsive
@import '../../scss/utilities';
@import '../../scss/mixins';

.pageHeader {
  @extend .row;
  h1 {
    margin-top: $sp * 3;
    @extend .col-xs-12;
  }
}
.pageBlock {
  background-color: $block-color;
  @include blockPadding;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jumpToContent {
  @extend .visible-xs-block;
  @extend .visible-sm-block;
  @extend .hidden-lg;
}
.tour {
  margin-top: $sp;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2 * $sp;

  .form {
    margin-bottom: 2 * $sp;
    grid-column: 1;
    grid-row: 1 / 4;
  }
  .tourImage {
    @extend .img-responsive;
    margin-bottom: $sp;
    grid-column: 2;
    grid-row: 1 / 2;
  }
  .tourDescription {
    grid-column: 2;
    grid-row: 2;
    align-self: start;
  }
  .tourName {
    margin-bottom: $sp;
  }
  .tourImage {
    @extend .img-responsive;
    margin-bottom: $sp;
  }
}

@media screen and (max-width: $screen-md) {
  .tour {
    grid-template-columns: 1fr;
    .form {
      grid-column: 1;
      grid-row: 3;
    }

    .tourImage {
      grid-column: 1;
      grid-row: 1;
    }

    .tourDescription {
      grid-column: 1;
      grid-row: 2;
    }
  }
}
img {
  opacity: 0;
  transition: opacity 0.5s;
}
img.loaded {
  opacity: 1;
}
</style>
